import { FC } from 'react'
import { useTypedSelector } from '../../hooks/useTypedSelector'
import { getTicketTypesAvailable } from '../../store/commonSlice'
import Input, { IInput } from '../form/Input'

const TicketTypeSelect: FC<IInput> = (props) => {
  // const types = useTypedSelector(getTicketTypes());
  const types = useTypedSelector(getTicketTypesAvailable())

  return (
    <Input
      options={types?.map(({ id, name }) => ({
        title: name,
        value: id,
      }))}
      {...props}
      value={props?.value || types?.[0]?.id}
    />
  )
}

export default TicketTypeSelect
